import BranchApi from 'api/branch';
import dealerApi from 'api/dealer';
import events from 'lib/events.js';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import Loader from 'components/loader';
import MissedProductSales from './missedProductSales/missedProductSales';
import ProductSales from './productSales';
import ProductsRecommended from './productRecommended';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router.js';
import routeUtils from 'util/routeUtils';
import SeasonsUsage from './seasonsUsage/seasonsUsage';
import session from 'services/sessionService';
import {connectToPerformanceFile, PERFORMANCE_KEYS} from 'ui/helpers/performanceFile';
import {intlShape, injectIntl} from 'react-intl';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

//Register in router
const render = (container, params) => {
  console.info('[UI.page.reports.sales] rendering page');
  ReactDOM.render(<IntlWrapper><BioGuardProductsReport subPageName={params.subPage} /></IntlWrapper>, container);
  events.publish('page-change', {page: 'reports'});
};

console.info('[UI.page.reports.bioguard] register route');
router.rr.add([{path: 'reports/bioguard/:subPage', handler: routeUtils.requireAdmin(render)}]);

class _BioGuardProductsReport extends Component {
  static propTypes = {
    subPageName: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      user: session.getUser(),
    };
  }
  componentWillMount() {

    let apis = [];

    apis.push(dealerApi.getDealer(this.state.user.dealerId));
    apis.push(BranchApi.getMyBranches());
    Promise.all(apis)
      .then(([dealer, branches]) => {
        this.setState({
          branches: branches.map(b => b.id),
          branchesInfo: branches,
          dealer: dealer,
          loaded: true,
        });
      })
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: 'Failed to load customer'});
      });
  }

  checkPOSPermission() {
    const {user, dealer} = this.state;

    if (!this.state.loaded) {
      return false;
    }

    if (user && dealer && dealer.CurrentPOSIntegration === 0) {
      return false;
    }

    if (user.isDealerAdmin && dealer) {
      return true;
    }

    if (user.isAdmin && dealer && dealer.managerDetailedReporting) {
      return true;
    }

    return !!(user.isTestStation && dealer && dealer.testerDetailedReporting);
  }

  checkTruBlueDealerStatus = () => {
    const {dealer} = this.state;

    if (!this.state.loaded) {
      return false;
    }

    return dealer && dealer.isTruBlueEligible;
  };

  render() {
    const {subPageName} = this.props;
    const {branches} = this.state;
    const {branchesInfo} = this.state;
    let {formatMessage} = this.props.intl;
    let subPage;
    let subPages = {
      'recommended-products': {name: formatMessage({id: 'reports.products.recommended'}), element: <ProductsRecommended branches={branches} branchesInfo={branchesInfo} />},
      'season-usage': {name: formatMessage({id: 'reports.season.usage'}), element: <SeasonsUsage branches={branchesInfo} truBlueActive={this.checkTruBlueDealerStatus()}/>},
    };

    if(subPageName !== 'missed-products' && subPageName !== 'product-sales') {
      subPage = subPages[subPageName].element;
    }
    if (this.checkPOSPermission()) {
      subPages['missed-products'] = {name: formatMessage({id: 'reports.missed.product.sales'}), element: <MissedProductSales branches={branches} branchesInfo={branchesInfo} />};
      subPages['product-sales'] = {name: formatMessage({id: 'reports.product.sales'}), element: <ProductSales branches={branches} branchesInfo={branchesInfo} />};

      let sortSubPages = {};

      sortSubPages['recommended-products'] = subPages['recommended-products'];
      sortSubPages['product-sales'] = subPages['product-sales'];
      sortSubPages['missed-products'] = subPages['missed-products'];
      sortSubPages['season-usage'] = subPages['season-usage'];

      subPages = sortSubPages;

      if(subPageName === 'missed-products' || subPageName === 'product-sales') {
        subPage = subPages[subPageName].element;
      }
    }

    if (this.state.loaded && !subPage) {
      location.hash = '';
    }

    const subPagesTabs = Object.keys(subPages)
      .map(sp => <a key={sp} className={subPageName === sp ? subPages[sp].className + ' active' : subPages[sp].className}
        href={'#reports/bioguard/' + sp}>{subPages[sp].name}
      </a>);

    return (
      <div className='container'>
        <div id='page-reports' >
          <div className='nav-tabs'>
            <Header mainTitle={formatMessage({id: 'reports.title'})} subTitle={formatMessage({id: 'reports.bioguard.products'})} mainTitleReturn='reports' />
          </div>
          <nav className='navigation-tabs'>
            {subPagesTabs}
          </nav>
          <Loader loaded={this.state.loaded}>
            <div className='report-details'>
              {subPage}
            </div>
          </Loader>
        </div>
      </div>
    );
  }
}

const BioGuardProductsReport = injectIntl(bindLocaleUpdate(connectToPerformanceFile(PERFORMANCE_KEYS.reports)(_BioGuardProductsReport)));

export default BioGuardProductsReport;
